import { Instruction } from 'Types/api';

export function isStructuredInstruction(
  instruction: string | Instruction,
): instruction is Instruction {
  return typeof instruction === 'object' && 'text' in instruction;
}

export function normalizeInstructions(instructions: (string | Instruction)[]): Instruction[] {
  return instructions.map((inst) => (isStructuredInstruction(inst) ? inst : { text: inst }));
}

export function getInstructionText(instruction: string | Instruction): string {
  return isStructuredInstruction(instruction) ? instruction.text : instruction;
}

export function getInstructionImageUrl(instruction: string | Instruction): string | undefined {
  return isStructuredInstruction(instruction) ? instruction.imageUrl : undefined;
}
